import config from "../../config";
import images from "../images/images";

import themeList from "../styles/themeList";

export const brandingConfig = (currentTheme) => {
    const { baseUrl } = config.api;
    const currentEnv = baseUrl.includes("checkventory")
        ? "checkventory"
        : "uverifi";

    /** Check for 
    1. currentTheme  
    2. controllerLogo not null
    3. controllerLogo  length as it returns string 
    */
    const logoCheck = () =>
        currentTheme &&
        currentTheme.controllerLogo &&
        currentTheme.controllerLogo.length > 0
            ? currentTheme.controllerLogo
            : images[currentEnv];

    /** Check for 
    1. currentTheme  
    2. controllerTheme  not null
    3. Serializer returns with mixed qoutes bring it to one 
    3. controllerTheme  doesn't have empty object
    */
    const themeCheck = () => {
        let theme;
        if (currentTheme && currentTheme.controllerTheme) {
            let orgTheme = JSON.parse(
                currentTheme.controllerTheme.replace(/'/g, '"')
            );
            Object.keys(orgTheme).length > 0
                ? (theme = orgTheme)
                : (theme = themeList[currentEnv]);
        } else {
            theme = themeList[currentEnv];
        }
        return theme;
    };

    const branding = {
        theme: themeCheck(),
        image: {
            name: currentEnv,
            loginLogo: logoCheck(),
            menuLogo: logoCheck()
        }
    };
    return branding;
};
